import { useMutation } from 'react-query';
import { getImagesAsync } from '../../index';

export const useGetImagesAsync = () => useMutation(getImagesAsync);
